import {Providers} from '@exp1/front-utils'
import {useIAmQuery} from '../hooks/useIAmQuery'
import {SSO_DOMAIN} from '../consts'

export const UserProvider = Providers.createUserProvider(SSO_DOMAIN, useIAmQuery)
